import { render, staticRenderFns } from "./delete-tag-contacts-dialog.vue?vue&type=template&id=28b37b9d"
import script from "./delete-tag-contacts-dialog.vue?vue&type=script&lang=js"
export * from "./delete-tag-contacts-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports